<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11NYVNf/tc-custom/9780062982735.jpg?1720280500664" alt="This image is the cover for the book Land of Roar, Land of Roar"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Land of Roar, Land of Roar
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Everyone remembers their secret imaginary world…but what if you discovered that yours was real?</b><b> </b></p><p>When Arthur and Rose were little, they were the heroes of Roar, a magical world they invented where the wildest creations of their imaginations roamed. Now that they’re eleven, Roar is just a distant memory. But it hasn’t forgotten them.</p><p>When their grandfather is spirited away into Roar by the villain who still haunts their nightmares, Arthur and Rose must go back to the world they’d almost left behind. And when they get there, they discover that Grandad isn’t the only one who needs their help.</p><p>This enchanting, action-packed novel is perfect for readers who’ve always dreamed of exploring Narnia and Neverland.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jenny McLachlan, Ben Mantle
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsPublishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?68bd1e84